/*
 * @Descripttion: 公司、企业相关常量
 * @Date: 2024-11-06 17:05:13
 */

/**
 * 公司证件编码类型
 */
export const COMPANYIDNOMAPPING: Record<
  number,
  { value: number; label: string }
> = {
  1: { value: 1, label: '统一社会信用代码' },
  2: { value: 2, label: '工商注册号' }
};

/**
 * 企业类型： 1:工业 2:服务商 3:供应商
 */
export enum entpTypeEnum {
  GY = 1,
  FWS = 2,
  GYS = 3
}

/**
 * 实名状态  10 未认证 20 认证中  30 认证成功  40 认证失败
 */
export const entitiesTypeMapping = {
  10: { value: 10, label: '未认证' },
  20: { value: 20, label: '认证中' },
  30: { value: 30, label: '认证成功' },
  40: { value: 40, label: '认证失败' }
};
